<template>
  <v-dialog
    v-model="dialog"
    max-width="100%"
    persistent
    transition="scroll-y-transition"
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <v-row
              dense
              class="text-h5 pb-0"
              style="font-weight: 500; color: black;"
            >
              <v-col>
                <strong>Please Review & Act on This Document</strong>
              </v-col>
            </v-row>
            <v-row
              dense
              class="align-center"
            >
              <v-col class="text-h6">
                "{{ documentName }}"
              </v-col>
            </v-row>
            <v-row
              dense
            >
              <v-col
                class="text-h6"
              >
                To be signed by <strong>{{ signeeName }}</strong>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="3"
            class="text-center align-center d-flex"
          >
            <v-img
              :src="companyLogo"
              alt="@/assets/systemx_MAIN_Colour_Black.svg"
              contain
              class="mx-auto"
              max-height="60"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-form ref="pdfAgreementForm">
        <v-card-actions>
          <v-row
            class="mx-0 px-3 align-center"
            style="background-color: #f0f0f0;"
          >
            <v-icon
              large
              color="#F0D549"
              class="pl-2"
            >
              mdi-label
            </v-icon>
            <v-col class="pl-1">
              <div>
                Please read the
                <a
                  @click="openSignatureDisclosure"
                >Electonic Record and Signature Disclosure</a>
              </div>
              <div>
                <v-checkbox
                  v-model="isAgreed"
                  label="I agree to use electronic records and signatures."
                  hide-details
                  :rules="[(v) => v === true || 'must be true']"
                />
              </div>
            </v-col>
            <v-col
              class="text-right"
            >
              <v-btn
                color="success"
                x-large
                label="continue"
                :disabled="!isAgreed"
                @click="agreeTerms"
              >
                continue
              </v-btn>
            </v-col>
            <v-col class="shrink text-center">
              <a
                class="mr-5"
                @click="close"
              >DECLINE</a>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
    <signature-disclosure-dialog
      ref="signatureDisclosureDialog"
      :company="company"
    />
    <prompt-dialog
      v-show="false"
      ref="promptDialog"
    />
  </v-dialog>
</template>
<script>
import SignatureDisclosureDialog from '@/components/SignPdf/Sign/SignatureDisclosureDialog.vue';
import PromptDialog from '@/components/PromptDialog.vue';
export default {
  components: { SignatureDisclosureDialog, PromptDialog },
  props: {
    documentName: {
      type: String,
      default: '',
    },
    signeeName: {
      type: String,
      default: '',
    },
    companyLogo: {
      type: String,
      default: '',
    },
    company: {
      type: Object,
      default: () => {}
    },
    token: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    valid: false,
    dialog: false,
    resolve: null,
    reject: null,
    isAgreed: false,
    userData: {},
    rules: {
      required: [(v) => !!v || 'Required.'],
    },
  }),
  computed: {},
  methods: {
    open() {
      this.dialog = true;
      this.userData = {};
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agreeTerms() {
      if (this.$refs.pdfAgreementForm.validate()) {
        this.dialog = false;
        this.$emit('agreed')
        this.resolve(true);
      }
    },
    openSignatureDisclosure() {
      this.$refs.signatureDisclosureDialog.open();
    },
    async close() {
      const confirm = await this.$refs.promptDialog.open({
        message: 'Are you sure you want to decline signing of this envelope? If declined you will not be able to access the envelope again.',
        confirmBtn: 'DECLINE'
      });
      if (!confirm) return;
      const data = { Token: this.token };
        const response = await this.$api.post(
          `sign-pdf/envelopes/decline`,
          data
        );
        if(!response) return
        this.$router.go()
    },
  },
};
</script>
<style scoped>
::v-deep .v-text-field input {
  font-size: 45px;
}
::v-deep .v-input input {
  max-height: 50px;
}
::v-deep .v-input--checkbox {
  margin-top: 0;
}
::v-deep .v-dialog {
  position: absolute;
  top: 0;
  overflow: hidden;
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
}
</style>
